const GOOGLE_MAPS_EMBED_PATH = '/maps/embed';

/** Returns a Google Maps *embed* URL suitable for `<iframe src>`, or null if unsupported. */
export function normalizeGoogleMapsEmbedUrl(url: string | undefined | null): string | null {
  const trimmed = url?.trim();
  if (!trimmed) return null;

  try {
    const parsed = new URL(trimmed);
    const host = parsed.hostname.replace(/^www\./, '').toLowerCase();

    if (host === 'google.com' && parsed.pathname.startsWith(GOOGLE_MAPS_EMBED_PATH)) {
      return parsed.toString();
    }

    if (host === 'maps.google.com' && parsed.pathname.startsWith(GOOGLE_MAPS_EMBED_PATH)) {
      return parsed.toString();
    }
  } catch {
    return null;
  }

  return null;
}

/** Human-facing maps link when embed URL is unavailable (never use embed URLs in `<a href>`). */
export function googleMapsViewUrlFromEmbed(url: string | undefined | null): string | null {
  const embedUrl = normalizeGoogleMapsEmbedUrl(url);
  if (!embedUrl) return null;

  try {
    const parsed = new URL(embedUrl);
    const pb = parsed.searchParams.get('pb');
    if (pb) {
      return `https://www.google.com/maps?pb=${encodeURIComponent(pb)}`;
    }
  } catch {
    return null;
  }

  return 'https://www.google.com/maps';
}
